import { useState } from 'react';
import { X } from 'lucide-react';

type ZoomableProductImageProps = {
  src: string;
  alt: string;
  loading?: 'lazy' | 'eager';
};

export function ZoomableProductImage({ src, alt, loading = 'lazy' }: ZoomableProductImageProps) {
  const [isOpen, setIsOpen] = useState(false);

  return <>
    <button type="button" onClick={() => setIsOpen(true)} className="block h-full w-full cursor-zoom-in touch-manipulation" aria-label={`放大查看：${alt}`}>
      <img src={src} alt={alt} className="h-full w-full object-contain" loading={loading} />
    </button>
    {isOpen && <div role="dialog" aria-modal="true" aria-label={`${alt} 大图预览`} onClick={() => setIsOpen(false)} className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 p-4">
      <button type="button" onClick={() => setIsOpen(false)} className="absolute right-4 top-4 inline-flex size-11 items-center justify-center rounded-full bg-white/15 text-white" aria-label="关闭大图预览"><X className="size-6" /></button>
      <img src={src} alt={alt} draggable={false} onClick={(event) => event.stopPropagation()} className="max-h-[90vh] max-w-full select-none object-contain" />
    </div>}
  </>;
}
